import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "preview", "placeholder" ]

  connect() {
    this.originalSrc = null;
    // Store the original src if a logo was rendered by the server
    if (this.previewTarget.dataset.hasAttachedImage === 'true' && this.previewTarget.src && !this.previewTarget.src.startsWith('blob:')) {
      this.originalSrc = this.previewTarget.src;
    }
  }

  previewFile() {
    const file = this.inputTarget.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        this.previewTarget.src = event.target.result;
        this.previewTarget.classList.remove('hidden');
        if (this.hasPlaceholderTarget) {
          this.placeholderTarget.classList.add('hidden');
        }
      }
      reader.readAsDataURL(file);
    } else {
      this.revertToInitialState();
    }
  }

  revertToInitialState() {
    if (this.previewTarget.dataset.hasAttachedImage === 'true' && this.originalSrc) {
      this.previewTarget.src = this.originalSrc;
      this.previewTarget.classList.remove('hidden');
      if (this.hasPlaceholderTarget) {
        this.placeholderTarget.classList.add('hidden');
      }
    } else {
      this.previewTarget.src = "";
      this.previewTarget.classList.add('hidden');
      if (this.hasPlaceholderTarget) {
        this.placeholderTarget.classList.remove('hidden');
      }
    }
  }
} 